import axios from "axios";
import { nomenclature } from "./nomenclature";
import { Settings } from "../../settings";

const groupnames = [
  "General",
  "Efficiency",
  "Safety",
  "Dimensions",
  "Electrical Ratings",
  "Connections Data",
  "Other technical Data"
];

/*const groupnames = [
  "General",
  "Efficiency",
  "Safety",
  "Dimensions",
  "Electrical Ratings",
  "Connections Data",
  "Other technical Data"
];*/

const updatedata = (data, refrigerent) => {

  var compare_data = {};
  for (var i = 0; i < groupnames.length; i++) {
    compare_data[groupnames[i].toLowerCase()] = [];
  }
  var slected_refrigerant_properties_legacy = data.legacy.refrigerants.filter(
    item => {
      if (item.id === refrigerent) {
        return item;
      }
    }
  );


  var slected_refrigerant_properties_doe = [];

  for (var i = 0; i < data.doe.length; i++) {
    slected_refrigerant_properties_doe.push(
      ...data.doe[i].refrigerants.filter(item => {
        if (item.id === refrigerent) {
          return item;
        }
      })
    );
  }
  slected_refrigerant_properties_doe.map((p, index) => {

    return p.properties
      .map(p_prop => {
   

        for (var i = 0; i < groupnames.length; i++) {
          if (p_prop.group.toLowerCase() === groupnames[i].toLowerCase()) {
            var found_key = false;
            for (
              var j = 0;
              j < compare_data[groupnames[i].toLowerCase()].length;
              j++
            ) {
              if (
                compare_data[groupnames[i].toLowerCase()][j].key === p_prop.key
              ) {
                compare_data[groupnames[i].toLowerCase()][j].value.doe[index] =
                  p_prop.value;
                found_key = true;
              }
            }
            if (!found_key) {
              let obj = {
                key: p_prop.key,
                value: { doe: [] }
              };
              if (index > 0) {
                for (var k = 0; k < index; k++) obj.value.doe[k] = " ";
              }
              obj.value.doe[index] = p_prop.value;
              compare_data[groupnames[i].toLowerCase()].push(obj);
       
            }
          }
        }
      })
      .filter(item => {
        if (typeof item != "undefined ") return item;
      });
  });

  var slected_refrigerant_properties_a2l = [];

  for (var i = 0; i < data.a2l.length; i++) {
    slected_refrigerant_properties_a2l.push(
      ...data.a2l[i].refrigerants.filter(item => {
        if (item.id === refrigerent) {
          return item;
        }
      })
    );
  }
  slected_refrigerant_properties_a2l.map((p, index) => {

    return p.properties
      .map(p_prop => {
   

        for (var i = 0; i < groupnames.length; i++) {
          if (p_prop.group.toLowerCase() === groupnames[i].toLowerCase()) {
            var found_key = false;
            for (
              var j = 0;
              j < compare_data[groupnames[i].toLowerCase()].length;
              j++
            ) {
              if (
                compare_data[groupnames[i].toLowerCase()][j].key === p_prop.key
              ) {
                compare_data[groupnames[i].toLowerCase()][j].value.a2l[index] =
                  p_prop.value;
                found_key = true;
              }
            }
            if (!found_key) {
              let obj = {
                key: p_prop.key,
                value: { a2l: [] }
              };
              if (index > 0) {
                for (var k = 0; k < index; k++) obj.value.doe[k] = " ";
              }
              obj.value.a2l[index] = p_prop.value;
              compare_data[groupnames[i].toLowerCase()].push(obj);
       
            }
          }
        }
      })
      .filter(item => {
        if (typeof item != "undefined ") return item;
      });
  });

  slected_refrigerant_properties_legacy.map(p => {

    return p.properties
      .map(p_prop => {


        for (var i = 0; i < groupnames.length; i++) {
          if (p_prop.group.toLowerCase() === groupnames[i].toLowerCase()) {
            var found_key = false;
            for (
              var j = 0;
              j < compare_data[groupnames[i].toLowerCase()].length;
              j++
            ) {
              if (
                compare_data[groupnames[i].toLowerCase()][j].key === p_prop.key
              ) {
                compare_data[groupnames[i].toLowerCase()][j].value.legacy =
                  p_prop.value;
                found_key = true;
              }
            }
            if (!found_key) {
              compare_data[groupnames[i].toLowerCase()].push({
                key: p_prop.key,
                value: { legacy: p_prop.value }
              });
            }
          }
        }
      })
      .filter(item => {
        if (typeof item != "undefined ") return item;
      });
  });


  return compare_data;
};

const mapdata = (data, refrigerent) => {
  let compare_data = {};
  data.doe = data.doe ? data.doe : [];
  for (var i = 0; i < groupnames.length; i++) {
    compare_data[groupnames[i]] = [];

    if (
      typeof data.a2l[0].refrigerants[refrigerent][groupnames[i]] ===
      "undefined"
    )
      data.a2l[0].refrigerants[refrigerent][groupnames[i]] = {};

    for (const [key, value] of Object.entries(
      data.a2l[0].refrigerants[refrigerent][groupnames[i]]
    )) {
      var tmp_doe = [];
      var tmp_a2l = [];
      var tmp_legacy = {};
      for (var m = 0; m < data.doe.length; m++) {
        tmp_doe.push(" ");
      }
      for (var n = 0; n < data.a2l.length; n++) {
        tmp_a2l.push(" ");
      }
      compare_data[groupnames[i]].push({
        key: key,
        value: { doe: tmp_doe, a2l: tmp_a2l, legacy: tmp_legacy }
      });
    }
    if(!(refrigerent === "R-454C" || refrigerent === "R-454A" || refrigerent === "R-455A")){

     // Handle legacy data
      if (
        typeof data.legacy.refrigerants[refrigerent][groupnames[i]] ===
        "undefined"
      )
        data.legacy.refrigerants[refrigerent][groupnames[i]] = {};

      for (const [key, value] of Object.entries(
        data.legacy.refrigerants[refrigerent][groupnames[i]]
      )) {
        var finditem = compare_data[groupnames[i]].find(fitem => {
          if (fitem.key === key) return true;
        });
        if(finditem)
          finditem.value.legacy = value;
      }

    // Handle DOE data
    for (var k = 0; k < data.doe.length; k++) {
      if (
        typeof data.doe[k].refrigerants[refrigerent][groupnames[i]] ===
        "undefined"
      )
        data.doe[k].refrigerants[refrigerent][groupnames[i]] = {};

      for (const [key, value] of Object.entries(
        data.doe[k].refrigerants[refrigerent][groupnames[i]]
      )) {
        var finditem = compare_data[groupnames[i]].find(fitem => {
          if (fitem.key === key) return true;
        });
        if(finditem)
          finditem.value.doe[k] = value;
      }
    }
  }
  // else {
        // Handle A2L data
        for (var p = 0; p < data.a2l.length; p++) {
          if (
            typeof data.a2l[p].refrigerants[refrigerent][groupnames[i]] ===
            "undefined"
          )
            data.a2l[p].refrigerants[refrigerent][groupnames[i]] = {};
    
          for (const [key, value] of Object.entries(
            data.a2l[p].refrigerants[refrigerent][groupnames[i]]
          )) {
            var finditem = compare_data[groupnames[i]].find(fitem => {
              if (fitem.key === key) return true;
            });
            if(finditem)
              finditem.value.a2l[p] = value;
          }
        }
      //  }
  }

  return compare_data;
};
// const fetchAllRefrigerents = data => {
//   return Object.keys(data.a2l[0].refrigerants);
// };


const fetchAllRefrigerents = data => {
  const legacyRefrigerants = Object.keys(data.legacy.refrigerants);
  const doeRefrigerants = data.doe
  ? data.doe
      .flatMap(item => Object.keys(item.refrigerants))
      .filter((value, index, self) => self.indexOf(value) === index) 
  : [];

  const a2lRefrigerants = data.a2l
    ? data.a2l
        .flatMap(item => Object.keys(item.refrigerants))
        .filter((value, index, self) => self.indexOf(value) === index) 
    : [];

  const allRefrigerants = [...new Set([...legacyRefrigerants, ...doeRefrigerants, ...a2lRefrigerants])];

  return allRefrigerants;
};
export const loadDescFile = filename => {
 
  return (dispatch, getState) => {
    axios
      .get("./files/" + filename)
      .then(function(response) {
   
        var r = response.data;
        dispatch({ type: "LOAD_FILE", fulldesc: r });
      })
      .catch(function(error) {

        dispatch({
          type: "LOAD_FILE_ERROR",
          status: "failed",
          message: "File cannot be loaded"
        });
      });
  };
};

export const loadNomanclature = () => {
  return (dispatch, getState) => {
    axios
      .get("./nomenclature.js")
      .then(function(response) {
        dispatch({ type: "LOAD_NOMENCLATURE", nomenclature: response.data });
      })
      .catch(function(error) {
   
        dispatch({
          type: "LOAD_NOMENCLATURE_ERROR",
          status: "failed",
          message: "Nomenclature Cannot be Loaded"
        });
      });
  };
};
export const loadRules = () => {
  return (dispatch, getState) => {
    axios
      .get("./rules.js")
      .then(function(response) {
        dispatch({ type: "LOAD_RULES", rules: response.data });
      })
      .catch(function(error) {
  
        dispatch({
          type: "LOAD_RULES_ERROR",
          status: "failed",
          message: "Rules Cannot be Loaded"
        });
      });
  };
};

/*export const loadCorrections = () => {
  return (dispatch, getState) => {
    axios
      .get("/rules.js")
      .then(function(response) {
        dispatch({ type: "LOAD_RULES", rules: response.data });
      })
      .catch(function(error) {
    
        dispatch({
          type: "LOAD_RULES_ERROR",
          status: "failed",
          message: "Rules Cannot be Loaded"
        });
      });
  };
};*/

export const compareModels = (compare_data = "") => {
  var code = 2;
  if (typeof compare_data === "undefined" || compare_data === "") code = 3;

  var re = new RegExp("/", "g");
  compare_data = compare_data.replace(re, "~");
  return (dispatch, getState) => {
    if (Array.isArray(compare_data)) compare_data = compare_data.join("");
    var url =
      Settings().LOAD_MODEL_URL + encodeURIComponent(compare_data) + "/new";
    //url = "BHT011L6B.json";
    axios
      .get(url)
      .then(function(response) {
        console.log("Nomenclature", response);
        if (response.data.status === "success") {
          

          var r = response.data;
          r.refrigerents = fetchAllRefrigerents(r);
   
          try {
            r.map_data = {};
            r.refrigerents.map(refrigerent => {
         
              r.map_data[refrigerent] = mapdata(r, refrigerent);
            
            });
          } catch (err) {
        var a = "";
          }

          r.refrigerents.map(refrigerent => {
            console.log("map data", refrigerent);
         
            console.log("map data", r.map_data[refrigerent]);

          
          });

  
          r.legacy.modelno = r.legacy.modelno.replace(/~/g, "/");
          let doe = r?.doe || [];
          for (var i = 0; i < doe.length; i++) {
      
            r.doe[i].modelno = r.doe[i].modelno.replace("?????", "#####");
            r.doe[i].modelno = r.doe[i].modelno.replace(/~/g, "/");
          }
          axios
            .get("./nomenclature.js")
            .then(function(response) {
           
              r.nomenclature = response.data;
              dispatch({ type: "LOAD_MODEL_NO", compare_data: r });
            })
            .catch(function(error) {
       
              dispatch({
                type: "LOAD_MODEL_NO_ERROR",
                status: "failed",
                message: "Network Error"
              });
            });
        } else {
          dispatch({
            type: "LOAD_MODEL_NO_ERROR",
            status: "failed",
            message: response.data.message || "Unknown Error"
          });
        }
      })
      .catch(function(error) {
    
        dispatch({
          type: "LOAD_MODEL_NO_ERROR",
          status: "failed",
          message: "Model Cannot be Loaded"
        });
      });
  };
};

export const LoadNewModels = (compare_data = "") => {
  var code = 2;
  if (typeof compare_data === "undefined" || compare_data === "") code = 3;

  return (dispatch, getState) => {
    if (Array.isArray(compare_data)) compare_data = compare_data.join("");
    /*"http://petalslice.com/loadmodel.php?name=" +     compare_data  )*/
    var re = new RegExp("/", "g");
    compare_data = compare_data.replace(re, "~");
    var url = Settings().LOAD_NEW_MODEL_URL + encodeURIComponent(compare_data);
    //url = "BHT011L6B.json";
    axios
      .get(url)
      .then(function(response) {
        if (
          response.data.status === "success" ||
          response.data["modelno"].length > 0
        ) {
  
          var r = {};
          r["doe"] = {};
          r["doe"]["modelno"] = response.data["modelno"].replace(/~/g,'/');
          r["doe"]["refrigerants"] = response.data["refrigerants"];
          r["type"] = response.data["type"];
          r["status"] = "success"; //response.data["type"];
          r.refrigerents = Object.keys(r.doe.refrigerants);

   
          /*r.map_data = {};
          r.refrigerents.map(refrigerent => {

            r.map_data[refrigerent] = mapdata(r, refrigerent);
          });*/

          r.doe.modelno = r.doe.modelno.replace("?????", "#####");

          axios
            .get("./nomenclature.js")
            .then(function(response) {
             
              r.nomenclature = response.data;
              dispatch({ type: "LOAD_NEW_MODEL_NO", compare_data: r });
            })
            .catch(function(error) {
           
              dispatch({
                type: "LOAD_NEW_MODEL_NO_ERROR",
                status: "failed",
                message: "Network Error"
              });
            });
        } else {
          dispatch({
            type: "LOAD_NEW_MODEL_NO_ERROR",
            status: "failed",
            message: response.data.message || "Unknown Error"
          });
        }
      })
      .catch(function(error) {
 
        //alert("Error");
        dispatch({
          type: "LOAD_NEW_MODEL_NO_ERROR",
          status: "failed",
          message: "Model Cannot be Loaded"
        });
      });
  };
};
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function replaceAll(str, term, replacement) {
  return str.replace(new RegExp(escapeRegExp(term), "g"), replacement);
}
export const LoadBuildModel = (compare_data = "") => {
  var code = 2;
  if (typeof compare_data === "undefined" || compare_data === "") code = 3;

  return (dispatch, getState) => {
    if (Array.isArray(compare_data)) compare_data = compare_data.join("");
    var url = Settings().LOAD_NEW_MODEL_URL + encodeURIComponent(compare_data);
    axios
      .get(url)
      .then(function(response) {
        if (
          response.data.status === "success" ||
          response.data["modelno"].length > 0
        ) {
          var r = {};
          r["doe"] = {};
          r["doe"]["modelno"] = response.data["modelno"];
          r["doe"]["refrigerants"] = response.data["refrigerants"];
          r["type"] = response.data["type"];
          r["status"] = "success"; //response.data["type"];
          r.refrigerents = Object.keys(r.doe.refrigerants);


          r.doe.modelno = r.doe.modelno.replace("?????", "#####");

          axios
            .get("./nomenclature.js")
            .then(function(response) {
  
              r.nomenclature = response.data;
              dispatch({ type: "LOAD_BUILD_MODEL_NO", compare_data: r });
            })
            .catch(function(error) {

              dispatch({
                type: "LOAD_BUILD_MODEL_NO_ERROR",
                status: "failed",
                message: "Network Error"
              });
            });
        } else {
          dispatch({
            type: "LOAD_BUILD_MODEL_NO_ERROR",
            status: "failed",
            message: response.data.message || "Unknown Error"
          });
        }
      })
      .catch(function(error) {

        dispatch({
          type: "LOAD_BUILD_MODEL_NO_ERROR",
          status: "failed",
          message: "Model Cannot be Loaded"
        });
      });
  };
};

export const FixOptionPackages = (modelno = "") => {
  //alert(modelno);
  return (dispatch, getState) => {
    var url = Settings().LIST_INVALID_PACKAGE_URL + encodeURIComponent(modelno);
    axios
      .get(url)
      .then(function(response) {
        if (response.data.status === "true") {

          response.data.status = "success";
          dispatch({
            type: "FIX_OPTION_PACKAGES",
            to_fix: response.data
          });
        } else {
          dispatch({
            type: "FIX_OPTION_PACKAGES",
            to_fix: response.message || "unknown Error"
          });
        }
      })
      .catch(function(error) {
        dispatch({
          type: "FIX_OPTION_PACKAGES_ERROR",
          status: "failed",
          message: "Model Cannot be Loaded" + error
        });
      });
  };
};
